import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      "fill-rule": "evenodd",
      d: "M12 3.773a8.227 8.227 0 1 0 0 16.454 8.227 8.227 0 0 0 0-16.454M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.582 17.367a.8.8 0 0 0 .458.133h.034a.82.82 0 1 0-.492-.133M13.827 11.854a5.3 5.3 0 0 0 1.138-1.309H15c.21-.38.317-.807.308-1.24a2.6 2.6 0 0 0-.9-1.992 3.32 3.32 0 0 0-2.276-.809 3.28 3.28 0 0 0-2.276.763 2.97 2.97 0 0 0-.922 1.64l-.171.705a.877.877 0 0 0 1.375.84.86.86 0 0 0 .344-.567l.057-.364a2.06 2.06 0 0 1 .546-1.139 1.4 1.4 0 0 1 1.002-.375 1.44 1.44 0 0 1 1.058.421 1.23 1.23 0 0 1 .433.945c-.001.187-.048.37-.137.535q-.303.422-.706.751-.449.38-.842.82c-.205.24-.37.514-.49.808a3.5 3.5 0 0 0-.204 1.252v.41a.83.83 0 1 0 1.662 0v-.114q-.004-.436.08-.865.064-.234.204-.433.312-.372.683-.683"
    }, null, -1)
  ])))
}
export default { render: render }